// Mirrors brian's BillingModeEnum.PER_TEAM_MANUAL.
const PER_TEAM_MANUAL_BILLING_MODE_ID = 1;

export const isPerTeamManualBilling = (billingModeId) =>
  billingModeId === PER_TEAM_MANUAL_BILLING_MODE_ID;

// The org's allowed email domains, primary first, with blanks dropped. Single
// source of truth for the teams table mapper, add-users modal and domains banner.
export const getAllowedEmailDomains = (organization) =>
  [
    organization?.emailDomain,
    ...(organization?.additionalEmailDomains ?? []),
  ].filter(Boolean);

export const mapTeamData = (data) => {
  const team = data?.team;
  const mappedData = {
    uuid: team?.uuid,
    name: team?.name,
    orgAllowsDirectMemberAdd:
      team?.organization?.allowsDirectMemberAdd,
    orgIsManualBilling: team?.organization?.isManualBilling,
    hasBillingSetup: !!team?.organization?.stripeCustomerId,
    orgIsPerTeamManualBilling: isPerTeamManualBilling(
      team?.organization?.billingModeId,
    ),
    emailDomain: team?.organization?.emailDomain,
    allowedEmailDomains: getAllowedEmailDomains(team?.organization),
    orgUuid: team?.organization?.uuid,
    orgCanDeleteUsers: team?.organization?.canDeleteUsers,
    location: team?.location,
    users: team?.userTeams?.map((userTeam) => ({
      uuid: userTeam?.user?.uuid,
      email: userTeam?.user?.email,
      numAppointmentsUsed: userTeam?.user?.numAppointmentsUsed,
      firstName: userTeam?.user?.firstName,
      lastName: userTeam?.user?.lastName,
      roleId: userTeam?.roleId,
      isAdmin: userTeam?.isAdmin,
      isDisabled: userTeam?.user?.isDisabled,
      accountType: userTeam?.user?.account?.accountType,
      isSelfSubscribed: userTeam?.isSelfSubscribed,
    })),
    userTeams: team?.userTeams,
    teamInvites: team?.teamInvites?.map((invite) => ({
      uuid: invite?.uuid,
      timeSent: invite?.timeSent,
      timeResponded: invite?.timeResponded,
      inviteeEmail: invite?.inviteeEmail,
      status: invite?.status,
      inviteeRoleId: invite?.inviteeRoleId,
    })),
  };
  return mappedData;
};

export const mapRoleIdToRole = (roleId) => {
  return (
    {
      1: "DVM",
      2: "Practice Manager",
      3: "Locum",
      4: "Technician",
      5: "Other",
    }[roleId] || "Role Not Assigned"
  );
};
export const nonBillableRoles = [2, 4, 5];

// Per-team manual plans are managed by Scribenote staff, so the plan is shown read-only.
export const getAccountPlanColumnMode = (team) => {
  if (team?.hasBillingSetup) return "editable";
  if (team?.orgIsPerTeamManualBilling) return "readonly";
  return null;
};

export const getAccountPlanLabel = (accountType) =>
  accountType === "unlimited" ? "Pro Plan" : "Free Plan";
